import { APP_VERSIONS } from 'constants/appVersions';
import { LANGUAGES } from 'constants/languages';
import { Resources } from 'constants/resources';

import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { required, useGetList } from 'react-admin';
import { AutocompleteInput, TextInput } from 'shared/react-admin/Inputs';
import { ReferenceInput } from 'shared/react-admin/ReferenceInputs';
import { Country } from 'types/embedded/country';
import { Currency } from 'types/embedded/currency';

export const OrderMethodsListFilter: React.FC = () => {
  const translate = useTypedTranslate();

  const { data: countries = [] } = useGetList<Country>(Resources.Countries);

  return (
    <>
      <ReferenceInput
        name="merchantId"
        reference="merchants"
        resource="merchants"
        source="merchantId"
      >
        <AutocompleteInput
          filterToQuery={(searchText: string) => ({ name: searchText })}
          helperText={false}
          label={translate('app.filter.merchant')}
          name="merchantId"
          optionText="name"
          validate={required()}
          variant="outlined"
        />
      </ReferenceInput>
      <TextInput
        helperText={false}
        label={translate('app.orderMethods.domain')}
        name="domain"
        source="domain"
        variant="outlined"
      />
      <AutocompleteInput
        choices={APP_VERSIONS}
        helperText={false}
        label={translate('app.orderMethods.appVersion')}
        name="appVersion"
        optionText="id"
        source="appVersion"
        variant="outlined"
      />
      <AutocompleteInput
        choices={countries}
        helperText={false}
        label={translate('app.filter.country')}
        name="country"
        optionText="name"
        optionValue="alphaCode"
        source="country"
        validate={required()}
        variant="outlined"
      />
      <ReferenceInput
        filter={{ active: true }}
        name="currency"
        perPage={300}
        reference="currencies"
        resource="currencies"
        source="currency"
      >
        <AutocompleteInput
          filterToQuery={(searchText: string) => ({ currency: searchText })}
          helperText={false}
          label={translate('app.filter.currency')}
          name="currency"
          optionText={(record: Currency) => `${record?.alphaCode}, ${record?.name}`}
          optionValue="alphaCode"
          validate={required()}
          variant="outlined"
        />
      </ReferenceInput>
      <TextInput
        helperText={false}
        id="customerId"
        label={translate('app.orderMethods.clientId')}
        name="customerId"
        source="customerId"
        validate={required()}
        variant="outlined"
      />
      <AutocompleteInput
        choices={LANGUAGES}
        helperText={false}
        label={translate('app.filter.language')}
        name="language"
        optionText="title"
        optionValue="code"
        source="language"
        variant="outlined"
      />
      <TextInput
        helperText={false}
        label={translate('app.orderMethods.depositsNumber')}
        name="countDeposit"
        source="countDeposit"
        variant="outlined"
      />
      <AutocompleteInput
        choices={[
          { id: 'payment', name: translate('app.direction.payment') },
          { id: 'payout', name: translate('app.direction.payout') },
        ]}
        fullWidth
        helperText={false}
        label={translate('app.filter.direction')}
        name="direction"
        validate={required()}
        variant="outlined"
      />
    </>
  );
};
